var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kstmod-item-relatedlist"},[(_vm.access.Act_New)?[_c('Action',{attrs:{"refId":_vm.refId}})]:_vm._e(),_c('List',{attrs:{"access":_vm.access,"dataList":_vm.dataList}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }